'use client';

import { useEffect, useState } from 'react';
import MetaPixelClient from './MetaPixelClient';
import FBSettingsService from '@/components/default/services/api/dashboard/fb.service';

type DataType = {
    meta_pixel_id: string;
    // meta_catalog_id?: string; // optional for product events
};

export default function PixelLoader() {
    const [pixelData, setPixelData] = useState<DataType | null>(null);

    useEffect(() => {
        FBSettingsService.getFBMetaPixel()
            .then((res) => {
                if (res.data) setPixelData(res.data);
            })
            .catch((err) => console.error('Pixel load error', err));
    }, []);

    // Do NOT render pixel until data exists
    if (!pixelData) return null;
    if (!pixelData.meta_pixel_id) return null;

    return <MetaPixelClient pixelData={pixelData} />;
}
